<template>
  <v-container>
    <v-row class="legend-container">
      <div
        class="legend-item"
        :key="service.abbreviation"
        v-for="service in services"
      >
        <div>
          <div :style="{ backgroundColor: service.color }" class="dot"></div>
          <span class="legend-title">{{ service.name }}</span>
        </div>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import Service from '@/dataAccess/models/Service'

export default {
  computed: {
    services() {
      return Service.all()
    }
  }
}
</script>

<style scoped>
.dot {
  height: 12px;
  width: 30px;
  border-radius: 4px;
  display: inline-block;
  margin-right: 5px;
}

.legend-container {
  margin-bottom: -25px;
  justify-content: flex-end;
}

.legend-title {
  opacity: 0.8;
}

.legend-item {
  margin-right: 15px;
}
</style>
